<template>
	<div id="detail-detail" class="w-100 p-b-30">
		<div class="ls-flex-col m-b-40">
			<div class="title ta-center fs-32 f-bold f-333 m-b-10">{{info.info && info.info.title || ''}}</div>
			<div class="title ta-center fs-24 f-666 m-b-25">{{info.info && info.info.subtitle || ''}}</div>
			<div class="time ls-flex ls-flex-center m-b-20">
				<span class="fs-16 f-999">时间：{{(info.info && info.info.date) || (info.info && info.info.create_time) || ''}}</span>
				<span class="fs-16 f-999 m-l-30">来源：{{(info.info && info.info.source) || ''}}</span>
				<span v-if="info.info && info.info.is_displayread" class="fs-16 f-999 m-l-30">阅读量：{{(info.info && info.info.visits) || ''}}</span>
			</div>
			<div class="line m-b-20"></div>
			<div v-if="info.info && info.info.video_file" class="m-b-20 ls-flex-center">
				<video :src="info.info.video_file" controls style="width: 360px;height: auto;"></video>
				<!-- <video src="http://www.centnor.com/uploads/20260116/f6312d62c70a25165ae0426a40adf3e9.mp4" controls style="width: 360px;height: auto;"></video> -->
			</div>
			<div class="content" v-html="content"></div>
		</div>
		<div class="ls-flex ls-al-center ls-jc-space-between m-b-40">
			<div></div>
			<span class="fs-16 f-999 m-l-30">责任编辑：{{(info.info && info.info.author) || ''}}</span>
		</div>
		<div class="bg-c-f4f4f4 b-r-10 p-20 m-b-50">
			<div class="fs-20 f-333 m-b-20">免责声明：</div>
			<div class="fs-16 f-999">
				凡本网注明“来源:XXX(非中北新闻网)”的作品，均转载自其它媒体，转载目的在于传递更多信息，
				并不代表本网赞同其观点和对其真实性负责。如因作品内容、版权和其它问题需要同本网联系，
				请在相关作品刊发之日起30日内进行。
			</div>
		</div>
		<div class="bg-c-f4f4f4 b-r-10 p-20 ls-flex ls-jc-space-between">
			<div @click="next(info.prev)" class="fs-16 f-666 cursor-pointer ls-flex-flex text-ellipsis-1 m-r-20">上一篇：{{info.prev && info.prev.status == 'ok' ? info.prev && info.prev.title : '没有了！'}}</div>
			<div @click="next(info.next)" class="fs-16 f-666 cursor-pointer ls-flex-flex text-ellipsis-1 ta-right">下一篇：{{info.next && info.next.status == 'ok' ? info.next && info.next.title : '没有了！'}}</div>
		</div>
		
	</div>
</template>

<script>
export default {
	props: ["obj","change"],
	data() {
		return {
			info:{},
			lastList:{},
			firstList:{},
			content:'',
			type:0,
			title:'',
			show:false,
			src:'',
			height:'',
			loading:''
		};
	},
	components: {
		
	},
	methods: {
		getDate(){
			let _self = this;
			// _self.content = _self.$publis.formatRichText(_self.info.info.content);
			_self.content = _self.info.info.content;
			// _self.content = _self.$publis.formatRichTextSpan(_self.content);
			// _self.content = _self.$publis.formatRichTextStrong(_self.content);
		},
		next(im){
			if (im.status == 'ok') {
				this.change(im.id);
			}
		}
	},
	created() {
		
	},
	mounted() {
		// this.init();
	},
	// 监听父组件传递的参数变化
	watch: {
		obj(curVal,oldVal){
			if(curVal){
				this.info = curVal;
				this.getDate();
			}
		},
	},
	beforeDestroy() {
		
	}
};
</script>

<style lang="scss">
	.parting-line{
		border: 1px solid #DDDDDD;
		background-color: #DDDDDD;
	}
	.bg-c-f4f4f4{
		background-color: #f4f4f4;
	}
	.ta-right{
		text-align: right;
	}
	.content{
		span{
			font-size: 20px !important;
		}
		p{
			font-size: 20px !important;
		}
	}
	.line{
		height: 1px;
		background-color: #DDDDDD;
	}
</style>